import React, { useEffect, useMemo, useState } from "react";

function NotesPage({ notes, addNote, updateNote, deleteNote }) {
  const [selectedId, setSelectedId] = useState(null);
  const [draft, setDraft] = useState({ title: "", body: "" });
  const [isNew, setIsNew] = useState(false);

  const selectedNote = useMemo(() => notes.find((note) => note.id === selectedId) || null, [notes, selectedId]);

  useEffect(() => {
    if (!selectedNote) {
      setDraft({ title: "", body: "" });
      return;
    }
    setDraft({ title: selectedNote.title || "", body: selectedNote.body || "" });
  }, [selectedNote]);

  const handleSelectNote = (note) => {
    setSelectedId(note?.id ?? null);
    setIsNew(false);
  };

  const handleCreateNew = () => {
    setSelectedId(null);
    setDraft({ title: "", body: "" });
    setIsNew(true);
  };

  const handleSave = () => {
    const title = draft.title.trim() || "Untitled";
    const body = draft.body.trim();
    if (isNew || !selectedNote) {
      const created = addNote({ title, body });
      if (created) {
        setSelectedId(created.id);
        setDraft({ title: created.title, body: created.body });
      }
      setIsNew(false);
      return;
    }
    updateNote(selectedNote.id, { title, body });
  };

  const handleDelete = () => {
    if (!selectedNote) return;
    deleteNote(selectedNote.id);
    setSelectedId(null);
    setDraft({ title: "", body: "" });
  };

  const noteCount = notes.length;

  return (
    <section className="notes-view">
      <aside className="notes-sidebar">
        <div className="notes-header">
          <h2>Notes</h2>
          <button type="button" onClick={handleCreateNew} className="notes-primary-btn">
            New Note
          </button>
        </div>
        <div className="notes-meta">{noteCount ? `${noteCount} saved` : "No notes yet"}</div>
        <ul className="notes-list">
          {notes.map((note) => (
            <li key={note.id}>
              <button
                type="button"
                className={`notes-list-item ${selectedId === note.id ? "active" : ""}`}
                onClick={() => handleSelectNote(note)}
              >
                <span className="notes-list-title">{note.title || "Untitled"}</span>
                <span className="notes-list-date">{new Date(note.updatedAt).toLocaleString()}</span>
              </button>
            </li>
          ))}
        </ul>
      </aside>

      <div className="notes-editor">
        <label className="notes-field">
          <span>Title</span>
          <input
            type="text"
            value={draft.title}
            onChange={(event) => setDraft((prev) => ({ ...prev, title: event.target.value }))}
            placeholder="Untitled"
          />
        </label>
        <label className="notes-field">
          <span>Note</span>
          <textarea
            value={draft.body}
            onChange={(event) => setDraft((prev) => ({ ...prev, body: event.target.value }))}
            placeholder="Type your note or to-do items"
          />
        </label>
        <div className="notes-actions">
          <button type="button" className="notes-primary-btn" onClick={handleSave}>
            Save
          </button>
          <button type="button" className="notes-secondary-btn" onClick={handleCreateNew}>
            Clear
          </button>
          <button
            type="button"
            className="notes-danger-btn"
            onClick={handleDelete}
            disabled={!selectedNote}
          >
            Delete
          </button>
        </div>
      </div>
    </section>
  );
}

export default NotesPage;
